import React from 'react';
import { BaseButton, useT } from '@repo/common';
import { ReactComponent as PlusIcon } from '@repo/common/assets/icons/20px/icon_20px_plus_outline.svg';

const ResumePlusCard = ({ onClick, isMyPage }) => {
  const t = useT();
  return (
    <div
      className={`
        group
        w-full
        flex flex-col gap-2 justify-center items-center
        border-[2.6px] border-dashed border-grayscale-gray02
        rounded-[15px] ${
          isMyPage
            ? 'bg-grayscale-gray00 w-full max-w-[300px] h-[219.875px] tabletH:min-w-[368.87px] tabletH:max-w-[765px] tabletH:h-[520px] p-4'
            : 'min-w-[320px] h-[360px]'
        }
        hover:bg-grayscale-gray01
        cursor-pointer tabletH:pt-[30px]
      `}
      onClick={onClick}
    >
      <BaseButton
        type='text'
        size='l'
        icon={<PlusIcon />}
        hoverclass='text-icon-placeholder group-hover:bg-grayscale-gray02 group-hover:text-text-placeholder'
      />
      <div className='tabletH:w-[212px] text-center text-text-placeholder tabletH:text-grayscale-gray03 typo-b12 tabletH:typo-b14Strong'>
        {t(
          'Create a resume Korean companies prefer',
          '한국 기업이 선호하는 이력서를 만들어 보세요',
        )}
      </div>
    </div>
  );
};

export default ResumePlusCard;
